<template>
  <div
    v-if="variants.v2 === variant && sidebarComponents.length > 0"
    class="tw-p-6"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded); border: 1px solid var(--c-border);`"  >
    <h3 class="tw-col-span-12 tw-pb-2">{{ vars.titleText }}</h3>

    <library-form v-if="form" :form="form" version="v1" :component="component" :is-form-name-visible="false"></library-form>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'ContactFormCard',

  mixins: [ComponentMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.contactForm);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },
});
</script>
